import {injectable} from "inversify";
import TeamFieldBasedCurrency from "@/modules/action-points/services/TeamFieldBasedCurrency";
import {GateTypeEnum} from "@/modules/action-points/enums";

@injectable()
export default class TrainingDFActionPointsCurrency extends TeamFieldBasedCurrency {
  protected getFieldName(): 'actionPointsTrainingDF' {
    return 'actionPointsTrainingDF';
  }

  protected getType(): GateTypeEnum {
    return GateTypeEnum.TRAINING_DF;
  }
}
